import React from 'react'
import PropTypes from 'prop-types'

import pluralize from 'pluralize'
import { Card, List } from 'semantic-ui-react'

import CardProperty from 'Components/CardProperty'
import Permissions from 'Components/Permissions'

import * as reservationHelpers from 'Global/Helpers/reservationHelpers'
import { getFormattedDateString } from 'Global/Helpers/timeHelpers'

const RugCardReservationsStatus = ({ current, upcoming }) => {
  if (current || upcoming.length > 0) {
    return (
      <Permissions
        permissions="rug.field.reservations"
        render={() => (
          <Card.Content extra>
            {current && (
              <List>
                <CardProperty color="black" icon="bookmark" popUpContent={reservationHelpers.buildCurrentPopUpString(current)}>
                  {`${getFormattedDateString(current.dateFrom)} –
                  ${getFormattedDateString(current.dateTo)}`}
                </CardProperty>
              </List>
            )}

            {!current && upcoming.length > 0 && (
              <List>
                <CardProperty icon="bookmark" popUpContent={upcoming}>
                  {`${upcoming.length}
                  Upcoming ${pluralize('Reservation', upcoming.length)}`}
                </CardProperty>
              </List>
            )}
          </Card.Content>
        )}
      />
    )
  }

  return null
}

RugCardReservationsStatus.propTypes = {
  current: PropTypes.object,
  upcoming: PropTypes.array.isRequired,
}

export default RugCardReservationsStatus
